import React, { ChangeEvent } from "react";
import { useState } from "react";
import { responseHero } from "../../../../utils/axiosInterceptor";
import { toast } from "react-toastify";
import { MiningMachine } from "../../../../models/miningmachine.model";
import { MiningEnergy } from "../../../../models/miningenergy.model";
import { MiningCoinConversion } from "../../../../models/mcc.model";

/*
    id: number;
  
    kwh: number;
    price: number;
    
    date: Date;
    miningMachineId: number;
    miningMachine: MiningMachine;
    customDistribution: boolean;
*/

type ModalProps = {
    title: string;
    showModal: boolean;
    closeModal: () => void;
    handleStateChange: () => void;
    miningMachine: MiningMachine | undefined;

    row: MiningCoinConversion | undefined;
}

type ModifiedPayload = Pick<MiningCoinConversion, 
"date" |
"quantity" |
"exchange_rate" |
"miningMachineId">

const ModifyCoinConversionModal = ({ title, showModal, closeModal, handleStateChange, miningMachine, row } : ModalProps) => {

    const [recordData, setRecordData] = useState<ModifiedPayload>({
        quantity: "",
        exchange_rate: 0,
        date: new Date(),
        miningMachineId: -1
    });


    React.useEffect(() => {
        if(!miningMachine) return;

        setRecordData((prevData) => ({
            ...prevData,
            miningMachineId: miningMachine?.id
        }))
    }, [miningMachine])

    React.useEffect(() => {
        if(!miningMachine || !row) return;

        setRecordData({
            quantity: row?.quantity,
            exchange_rate: row?.exchange_rate,
            date: row?.date,
            miningMachineId: row?.miningMachineId
        })
    }, [miningMachine, row])

    const handleChange = (
        type: keyof ModifiedPayload,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        let inputValue = e.target.value;
    
        setRecordData((prevData) => {
            let updatedValue: any;
    
            switch (type) {
                case "quantity":
                    if (/^(\d*\.)?\d{0,8}$/.test(inputValue)) {
                        updatedValue = inputValue;
                    } else {
                        return prevData;
                    }
                    break;
                case "exchange_rate":
                    if (/^(\d*\.)?\d{0,8}$/.test(inputValue)) {
                        updatedValue = parseFloat(inputValue);
                    } else {
                        return prevData;
                    }
                    break;
                case "date":
                    updatedValue = updatedValue;
                    break;
                case "miningMachineId":
                    updatedValue = inputValue;
                    break;
                default:
                    updatedValue = inputValue;
            }
    
            return {
                ...prevData,
                [type]: updatedValue
            };
        });
    }
          
    
    const makeRecord = async () => {
        console.log(JSON.stringify(recordData, null, 2))
        await responseHero.put(`${process.env.REACT_APP_API_URL}/miningcc/${row?.id}`, { miningCC: recordData }).then((response) => {
            closeModal()
            handleStateChange();
            toast.success(`Sikeresen frissítettél egy konverziót!`);
        }).catch(error => {
            console.error(JSON.stringify(error.response.data.message, null, 2));
            closeModal()
            toast.error(`Sikertelen adatrögzítés!`);
        })
    }

    return (
    <>
        {showModal && (
            <>
            <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-full my-6 mx-auto max-w-4xl">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
                            <h3 className="text-xl text-brown font-semibold"><span className="text-dark-blue">BÁNYAGÉP</span> - {title}</h3>
                        </div>
                        <div className="relative p-6 flex-auto">
                        <form>
                                <div className="flex p-2 rounded shadow-md">

                                     <div className="w-1/3 pr-2 text-center justify-center items-center">
                                        <label className="block text-sm font-bold mt-5 text-brown text-center justify-center" htmlFor="crypto_1">
                                        <span className="text-success">{miningMachine?.name} </span> <br/>Váltás dátuma
                                        </label>
                                        <input
                                            value={recordData?.date?.toString().split('T')[0]}
                                            onChange={(e) => handleChange('date', e)}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="name" type="date" placeholder="Dátum"/>
                                    </div>

                                    <div className="w-1/3 pr-2 text-center justify-center items-center">
                                        <label className="block text-sm font-bold mt-5 text-brown text-center justify-center" htmlFor="crypto_1">
                                            <span className="text-success">{miningMachine?.name} </span> <br/>Coin mennyiség
                                        </label>
                                        <input
                                            value={recordData?.quantity}
                                            onChange={(e) => handleChange('quantity', e)}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="name" type="text" placeholder="Coin mennyiség (BTC)"/>
                                    </div>

                                    <div className="w-1/3 pr-2 text-center justify-center items-center">
                                        <label className="block text-sm font-bold mt-5 text-brown text-center justify-center" htmlFor="crypto_1">
                                        <span className="text-success">{miningMachine?.name} </span> <br/>Árfolyam ($)
                                        </label>
                                        <input
                                        value={recordData?.exchange_rate}
                                        onChange={(e) => handleChange('exchange_rate', e)}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="date" type="number" placeholder="Árfolyam USDT-ben"/>
                                    </div>

                                    
                                </div>
                            </form>
                        </div>
                        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                        <button
                            className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={closeModal}
                        >
                            Mégse
                        </button>
                        <button
                            className="text-cream bg-dark-blue font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={makeRecord}
                        >
                            Hozzáad
                        </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm"></div>
            </>
        )}
    </>
  );
};

export default ModifyCoinConversionModal;